export default {
  SET_COLUMN_SIZE: 'SET_COLUMN_SIZE',
  SET_GAME: 'SET_GAME',
  SET_PARAMS: 'SET_TRANSACTION_PARAMS',
  SET_PAYLINES: 'SET_PAYLINES',
  SET_ROUND: 'SET_ROUND',
  SET_SYMBOL_SIZE: 'SET_SYMBOL_SIZE',
  SET_VERSION_TYPE: 'SET_VERSION_TYPE',
};
